export const ASSIGNED_INSTRUCTOR_FIELD = 'AssignedInstructorID';
export const INSTRUCTOR_HIDDEN_CLASS_STATUSES = new Set(['4', '5', '7', '8']);

export const sortAssignedClassesByDate = (classes = []) => (
  [...classes].sort((a, b) => Number(a?.Date || 0) - Number(b?.Date || 0))
);

export const filterInstructorVisibleClasses = (classes = []) => (
  classes.filter((classData) => !INSTRUCTOR_HIDDEN_CLASS_STATUSES.has(String(classData?.classStatus)))
);

export const filterNeedsAttentionClasses = (classes = [], nowMs = Date.now()) => (
  filterInstructorVisibleClasses(classes).filter((classData) => {
    const endMs = Number(classData?.EndDate || classData?.Date || 0);
    const hasCompletionStatus = classData?.status !== undefined
      && classData?.status !== null
      && String(classData.status).trim() !== '';

    return Number.isFinite(endMs) && endMs < Number(nowMs) && !hasCompletionStatus;
  })
);

export const buildAssignedInstructorClassesQuery = ({
  db,
  collection,
  query,
  where,
  instructorId,
}) => query(
  collection(db, 'Classes'),
  where(ASSIGNED_INSTRUCTOR_FIELD, '==', instructorId)
);

buildAssignedInstructorClassesQuery.sortClasses = sortAssignedClassesByDate;
